import * as React from 'react';

import { connect, useDispatch } from 'react-redux';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';

import Box from '@components/layout/box';
import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

import AccountItem from './account-item';
import WalletTotalCtrl from './wallet-total';
import AddAccountItem from './add-account-item';
import { ConnectedAccount } from '@services/stripe-connect/types/connected-account';
import {
  CreateConnectedAccount,
  CreateLoginLink,
  CreateOnboardingLink,
} from '../../../../store/stripe-connect/action-creators';
import { isAddressReady } from '../../../../utils/user/is-address-ready';
import SimpleUser from '../../../../../../../common/types/user/simple-user';
import AccessStripeDashboard from './access-stripe-dashboard';
import { push } from 'connected-react-router';

interface WalletPageProps {
  className?: string;
  isMobile: boolean;
  account?: ConnectedAccount;
  redirecting: boolean;
  userProfile: Partial<SimpleUser>;
}

const mapStateToProps = (state: AppState): WalletPageProps => ({
  isMobile: state.ui.mobile,
  account: state.stripeConnect.account,
  redirecting: !!state.stripeConnect.redirecting,
  userProfile: state.user.profile || {},
});

export const WalletPage: React.FC<WalletPageProps> = (props) => {
  const dispatch = useDispatch();

  const handleAddAccount = async () => {
    if (!isAddressReady(props.userProfile)) {
      dispatch(push('/user/general?pageSource=WALLET'));
      return;
    }
    if (!props.account) {
      dispatch(new CreateConnectedAccount({ user_profile: props.userProfile }));
    } else {
      dispatch(new CreateOnboardingLink(props.account!.id));
    }
  };

  return (
    <MotionOpacity className={props.className}>
      {!props.isMobile ? (
        <Typography type="subheader" customFont="semi-bold" className="mb-30">
          <Translate id="USER_PROFILE.WALLET.WALLET_NAV" />
        </Typography>
      ) : null}
      <Grid>
        <WalletTotalCtrl earningsKey="OWNER" />
        <Box noBorderTop>
          <Typography
            type="section-title"
            customFont="medium"
            className="accounts-title mb-20"
          >
            <Translate id="USER_PROFILE.WALLET.ACCOUNTS.TITLE" />
          </Typography>
          <AccountsList>
            <AddAccountItem
              currentAccount={props.account}
              onClick={handleAddAccount}
              redirecting={props.redirecting}
              addressReady={isAddressReady(props.userProfile)}
            />
            <AccessStripeDashboard
              currentAccount={props.account}
              onClick={() => dispatch(new CreateLoginLink(props.account!.id))}
            />
            {props.account?.externalAccounts?.map((account) => (
              <AccountItem key={account.id} account={account} />
            ))}
          </AccountsList>
        </Box>
      </Grid>
    </MotionOpacity>
  );
};

const AccountsList = styled.div`
  display: grid;
  grid-gap: 10px;
`;

export default connect(mapStateToProps)(WalletPage);
